import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { RoutingHelper } from '@helpers/routinghelper';
import { ValueAccessorHelper } from '@helpers/value-accessor-helper';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { HttpBaseService } from '@service/http-base.service';
import { AuthTokenHelper } from '@helpers/auth-token-helper';
import { AuthService } from '@service/auth.sevice';
import { MatDialog } from '@angular/material/dialog';
import { ClaimTransaction } from '@models/claimdashboard/claim-detail.model';
import { BeyondEMRConstants } from '@helpers/beyondemrconstants'


@Component({
  selector: 'app-transaction-tab',
  templateUrl: './transaction-tab.component.html',
  styleUrls: ['./transaction-tab.component.css']
})

export class TransactionTabComponent extends ValueAccessorHelper<any> implements OnInit {
  @Input() transactions: Array<ClaimTransaction>;
  @Input() encounterId: number;
  submitted = false;
  returnUrl: string;
  showValidation: boolean;
  public apiURL = null;
  formType: string;
  constants: any = BeyondEMRConstants;
  postURL: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private routingHelper: RoutingHelper,
    private httpService: HttpBaseService,
    private authHelper?: AuthTokenHelper,
    private authService?: AuthService,
    private dialog?: MatDialog,
  ) {
    super();
  }

  ngOnInit() {
  }

  editStatusURL() {
    let encodeEncounterId = this.routingHelper.EncodeParam(this.encounterId);
    this.router.navigate([`/encounterform/edit/${encodeEncounterId}`])
  }
}
